import { extraReducers } from "./extra-reducers.js";
import { initialState } from "./initial-state.js";
import { reducers_exports } from "./reducers.js";
import { createSlice } from "@reduxjs/toolkit";
var slice = createSlice({
	name: "i18n",
	initialState,
	reducers: reducers_exports,
	extraReducers
});
var actions = slice.actions;
var reducer = slice.reducer;
//#endregion
export { actions, reducer, slice };

//# sourceMappingURL=slice.js.map